import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CentreProvider } from "@/context/CentreContext";
import { UIProvider } from "@/context/UIContext";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";

import Home from "@/pages/Home";
import Reprogrammation from "@/pages/Reprogrammation";
import StagePage from "@/pages/StagePage";
import Services from "@/pages/Services";
import E85 from "@/pages/E85";
import Banc from "@/pages/Banc";
import ServiceGeneric from "@/pages/ServiceGeneric";
import Centres from "@/pages/Centres";
import CentreDetail from "@/pages/CentreDetail";
import Realisations from "@/pages/Realisations";
import About from "@/pages/About";
import FileService from "@/pages/FileService";
import Franchise from "@/pages/Franchise";
import Contact from "@/pages/Contact";
import Shop from "@/pages/Shop";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import OrderSuccess from "@/pages/OrderSuccess";
import { CartProvider } from "@/context/CartContext";
import BrandsHub from "@/pages/BrandsHub";
import BrandPage from "@/pages/BrandPage";
import LegalPage from "@/pages/LegalPage";
import CookieBanner from "@/components/CookieBanner";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-center" richColors />
      <BrowserRouter>
        <AuthProvider>
          <CentreProvider>
            <UIProvider>
              <CartProvider>
              <Routes>
                <Route element={<PublicLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/reprogrammation" element={<Reprogrammation />} />
                  <Route path="/reprogrammation/:stage" element={<StagePage />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/e85" element={<E85 />} />
                  <Route path="/services/banc-de-puissance" element={<Banc />} />
                  <Route path="/services/:slug" element={<ServiceGeneric />} />
                  <Route path="/centres" element={<Centres />} />
                  <Route path="/centres/:slug" element={<CentreDetail />} />
                  <Route path="/realisations" element={<Realisations />} />
                  <Route path="/nous-connaitre" element={<About />} />
                  <Route path="/file-service" element={<FileService />} />
                  <Route path="/devenir-franchise" element={<Franchise />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/reprogrammation-moteur" element={<BrandsHub />} />
                  <Route path="/reprogrammation-moteur/:slug" element={<BrandPage />} />
                  <Route path="/mentions-legales" element={<LegalPage slug="mentions-legales" />} />
                  <Route path="/confidentialite" element={<LegalPage slug="confidentialite" />} />
                  <Route path="/cgv" element={<LegalPage slug="cgv" />} />
                  <Route path="/boutique" element={<Shop />} />
                  <Route path="/boutique/panier" element={<CartPage />} />
                  <Route path="/boutique/merci" element={<OrderSuccess />} />
                  <Route path="/boutique/:slug" element={<ProductPage />} />
                </Route>
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
              <CookieBanner />
              </CartProvider>
            </UIProvider>
          </CentreProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
